import ListView from "@/components/AntListView";
import React, {useEffect, useRef, useState} from "react";
import Style from "./index.module.scss";
import {Checkbox} from "antd-mobile";
import ConfirmToPointModal from "@/view/nftPad/paySuccess/components/confirmToPointModal";
import NFTModal from "@/components/NFTModal";
import {useNavigate} from "react-router-dom";

const ToPointComponent = ({dataSource = []}) => {
  const [value, setValue] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const pageDom = useRef(null);
  const navigate = useNavigate();

  const renderItem = (item) => {
    return (
      <div className={Style.checkCard}>
        <Checkbox value={item.nftNo}>
          <div className={Style.itemBox}>
            <img className={Style.imgBox} src={item.image} alt=""/>
            <div className={Style.rightBox}>
              <div className={Style.itemName}>{item.collectionName}</div>
              <div className={Style.itemJifenText}>{item?.convertCount || 0} {item.convertType === 1 ? '宝石' : '积分'}</div>
            </div>
          </div>
        </Checkbox>
      </div>
    )
  }
  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }
  const handleSubmit = () => {
    const ModalInstance = NFTModal.show({
      content: <ConfirmToPointModal
        onClose={() => ModalInstance?.close()}
        selectNftNo={value}
        totalCount={totalCount}
        convertType={dataSource[0]?.convertType}
        successCallBack={() => {
          ModalInstance?.close()
          onBack()
        }}
      />,
      getContainer: pageDom.current,
    });
  }

  useEffect(() => {
    setTotalCount(dataSource.filter(item => value.includes(item.nftNo)).reduce((acc, item) => acc + item.convertCount, 0))
  }, [value]);
  return (
    <div className={Style.container} ref={pageDom}>
      <div className={Style.list}>
        <div>
          <Checkbox.Group
            value={value}
            onChange={v => {
              setValue(v)
            }}
          >
            <ListView
              dataSource={dataSource}
              renderItem={renderItem}
              hasMore={false}
              isLoad={true}
              style={{paddingTop: 50}}
              onRefresh={() => {
              }}
            />
          </Checkbox.Group>
        </div>
      </div>
      <div className={Style.footerBox}>
        <Checkbox
          indeterminate={value.length > 0 && value.length < dataSource?.length}
          checked={value?.length > 0 && value.length === dataSource?.length}
          onChange={checked => {
            if(dataSource?.length > 0) {
              if (checked) {
                setValue(dataSource.map(item => item.nftNo))
              } else {
                setValue([])
              }
            }
          }}
          className={Style.checkAll}
        >
          <span>全选</span>
        </Checkbox>
        <div className={Style.buttonBox}>
          <div className={Style.text}>当前已选转化 <span className={Style.colorText}>{totalCount}</span> 个{dataSource[0]?.convertType === 1 ? '宝石' : '积分'}</div>
          <button disabled={!(value?.length > 0)} className={value.length > 0 ? Style.button : Style.disabledButton} onClick={handleSubmit}>确认转化{dataSource[0]?.convertType === 1 ? '宝石' : '积分'}</button>
        </div>
      </div>
    </div>
  )
}
export default ToPointComponent